<template lang='pug'>
.search-container
    van-search(v-model='value', placeholder='请输入产品名称')
    ListTransition.content-list(
        :list='list',
        rowKey='id',
        anime='scale',
        v-slot='{item}'
    )
        .row(@click='goDetail(item)') {{ item.detail.name }}
</template>

<script>
import products from '@/assets/data/dic'
import ListTransition from './components/ListTransition'

import { mapActions } from 'vuex'
import { getDataRows, searchDataRowsInGlobal, searchview } from '@custouch/proxy-use'
import { Toast } from 'vant'
export default {
    name: 'search',
    data() {
        return {
            value: '',
            products: [],
            list: []
        }
    },
    components: {
        ListTransition
    },
    computed: {
        // list() {
        //     if (!this.value) return []
        //     // const ret = await searchDataRowsInGlobal()
        //     return []
        //     // return this.products.filter(item => item.name.replace(/\s/g,'').toLowerCase().includes(this.value.replace(/\s/g,'').toLowerCase()))
        // }
    },
    watch: {
        value(val){
            this.onSearch(val)
        }
    },
    methods: {
        ...mapActions(['getJson']),
        async onSearch(val){
            this.list = []
            if(!val) return
            searchview({
                title: this.$route.meta.title,
                searchVal: val,
                searchFor: 'ifm搜索'
            })
            const { DATA } = window.env
            const { module, template } = DATA
            const [ret, relatedRet,tachRet,caseRet ] = await Promise.all([
                searchDataRowsInGlobal({
                    dataModules: [
                        {id: module.productTech.id, dataTemplates: [{id: template.productTech,customIds: ['name']}]},
                        {id: module.documentCatalog.id,dataTemplates: [{id: template.docsPdf, customIds: ['name']}, {id: template.docsVideo,customIds: ['name']}]}
                    ],
                    groupBy: ['dataModule','dataHierarchy'],
                    searchKey: val,
                    recursive: true
                }),
                getDataRows({
                    dataTemplateId: template.relatedProducts,
                    index:1,
                    size: 99,
                    searchKey: val,
                    customIds: ['name']
                }),
                getDataRows({
                    dataTemplateId: template.relatedProductsTech,
                    index:1,
                    size: 99,
                    searchKey: val,
                    customIds: ['name']
                }),
                getDataRows({
                    dataTemplateId: template.productCase,
                    index:1,
                    size: 99,
                    searchKey: val,
                    customIds: ['name']
                }),
            ])
            for(let mId in ret.data){
                for(let hId in ret.data[mId]){
                    ret.data[mId][hId].map(item=>{
                        let index = this.list.findIndex(key=>key.id === item.id)
                        if(index === -1){
                            this.list.push({mId,hId,...item})
                        }
                    })
                }
            }
            [...relatedRet.data,...tachRet.data,...caseRet.data].map(item=>{
                this.list.push(item)
            })
        },
        goDetail(item){
            let route = {}
            const { DATA } = window.env
            const { module, template } = DATA
            if(item.mId && [template.docsPdf, template.docsVideo].includes(item.dataTemplateId)){
                if(item.dataTemplateId === template.docsPdf){
                    route = {
                        name: 'pdfViewer',
                        params: {
                            rId: item.id
                        },
                        query: {
                            hId: item.hId
                        }
                    }
                }else{
                    route = {
                        name: 'videoViewer',
                        params: {
                            rId: item.id
                        },
                        query: {
                            hId: item.hId
                        }
                    }
                }
            }else{
                if(item.dataTemplateId === template.productCase && item.detail.link){
                    window.location.href = item.detail.link
                    this.$message.loading({
                        message: '跳转中...',
                        forbidClick: true,
                        duration: 3000
                    })
                    return
                }else{
                    route = {
                        name: 'productDetail',
                        params: {
                            rId: item.id
                        },
                        query: {
                            hId: item.hId
                        }
                    }
                }
            }
            if(route){
                this.$router.push(route)
            }else{
                Toast('暂未开放')
            }
        }
    },
    async created() {
        // const dataDic = Object.assign({}, products, {
        //     精选资料: window.env.VUE_APP_DATA_DOCUMENT
        // })
        // const sections = Object.keys(dataDic)
        // const dataGroup = Object.values(dataDic).map(item => this.getJson(item))
        // let [...allProducts] = await Promise.all(dataGroup)
        // const lastIndex = allProducts.length - 1
        // allProducts.forEach((sectionItem, index) => {
        //     sectionItem.forEach(item => {
        //         item.section = sections[index]
        //         if (index === lastIndex) {
        //             const { type, id, name } = item
        //             item.to = { name: type === 'video' ? 'videoViewer' : 'pdfViewer', params: { id }, query: { name } }
        //         } else {
        //             item.to = { name: "productDetail", params: { section: item.section, name: item.name } }
        //         }
        //     })
        // })
        // this.products = allProducts.flat().reduce((pre, cur) => {
        //     const hasOld = pre.find(item => {
        //         if (item.id && cur.id) {
        //             return item.type === cur.type && item.id === cur.id
        //         }
        //         return item.name === cur.name
        //     })
        //     if (!hasOld) {
        //         pre.push(cur)
        //     }
        //     return pre
        // }, [])
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';
.search-container {
    padding: 1.2rem 1rem;
}
.van-search {
    padding-left: 0;
    padding-right: 0;
}
.row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // line-height: 2rem;
    border-bottom: 1px solid #f2f2f2;
    padding: 0.7rem 0.2rem;
    &::after {
        content: '';
        .arrow(right,0.3rem,#64a7b1);
    }
}
</style>